/* Tamper- und PUQ-Groessen: Finder auf der Produktseite und Pruefung im
   Warenkorb (PO 01.10.2026). Markup: snippets/nb-tamper-finder.liquid und
   snippets/nb-tamper-pruefung.liquid, Daten:
   templates/collection.tamper-json.liquid.

   GROESSE AUS DEM OPTIONSWERT. Die Produkte schreiben ihre Groessen
   unterschiedlich ("Ø 58.3", "58.3mm", "Ø 57"), deshalb zaehlt nur die
   Zahl. Zwei Groessen gelten als gleich, wenn sie hoechstens 0,1 mm
   auseinanderliegen (58,3 und 58,35).

   GEMERKTE MASCHINE. Die Wahl im Finder liegt in localStorage unter
   "nb-tamper-maschine". Der Warenkorb nutzt sie nur, wenn dort keine
   Maschine liegt, und formuliert dann vorsichtiger. */
(() => {
  const SPEICHER = 'nb-tamper-maschine';
  const zahl = (wert) => {
    const m = String(wert || '').replace(',', '.').match(/(\d{2}(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : null;
  };
  const gleich = (a, b) => a != null && b != null && Math.abs(a - b) < 0.11; // 58,3 und 58,35 gelten als gleich (Wiedecent 58,35 passt laut Wiedemann in gaengige 58-mm-Siebe)
  const anzeigen = (mm) => {
    const s = String(mm);
    return (document.documentElement.lang || 'de').toLowerCase().startsWith('de') ? s.replace('.', ',') : s;
  };
  const liste = (w) => (Array.isArray(w) ? w : w ? [w] : []).map(zahl).filter((x) => x != null);
  const gemerkt = () => { try { return JSON.parse(localStorage.getItem(SPEICHER) || 'null'); } catch (e) { return null; } };
  const merken = (m) => { try { localStorage.setItem(SPEICHER, JSON.stringify(m)); } catch (e) {} };
  const sollFuer = (m, puq) => { const q = liste(m.q), t = liste(m.t); return puq && q.length ? q : t; };

  /* Suche mit Tippfehler-Toleranz: "Bezzerra aria" findet "Bezzera Aria".
     Jedes Suchwort muss ein Wort im Namen treffen, als Anfang oder mit
     hoechstens einem Fehler (ab 4 Buchstaben). */
  const woerter = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9.]+/g, ' ').trim().split(' ').filter(Boolean);
  const abstand = (a, b) => {
    const d = Array.from({ length: a.length + 1 }, (_, i) => [i]);
    for (let j = 1; j <= b.length; j++) d[0][j] = j;
    for (let i = 1; i <= a.length; i++) for (let j = 1; j <= b.length; j++)
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    return d[a.length][b.length];
  };
  const wortPunkte = (q, w) => {
    if (w.startsWith(q)) return 3;
    if (q.length >= 4 && abstand(q, w.slice(0, q.length)) <= 1) return 2;
    if (q.length >= 4 && abstand(q, w) <= 1) return 2;
    return 0;
  };
  const punkte = (q, w) => {
    let summe = 0;
    for (const t of q) { const p = Math.max(0, ...w.map((x) => wortPunkte(t, x))); if (!p) return 0; summe += p; }
    return summe;
  };

  /* ---------- Finder auf der Produktseite ---------- */
  let maschinenLaden = null;
  const maschinen = (quelle) => {
    if (!maschinenLaden) {
      maschinenLaden = fetch(quelle, { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.text() : '[]'))
        .then((t) => { try { return JSON.parse(t.trim() || '[]'); } catch (e) { return []; } })
        .catch(() => []);
    }
    return maschinenLaden;
  };

  const finderStarten = (box) => {
    if (box.dataset.nbTfBereit) return;
    box.dataset.nbTfBereit = '1';
    const pos = parseInt(box.dataset.pos, 10);
    const puq = box.dataset.art === 'puq';
    let werte = [];
    try { werte = JSON.parse(box.querySelector('[data-nb-tf-werte]').textContent); } catch (e) {}
    const eingabe = box.querySelector('input');
    const listeEl = box.querySelector('.nb-tf__liste');
    const ergebnis = box.querySelector('[data-nb-tf-ergebnis]');
    const kauf = box.closest('[data-section-id], section, .shopify-section') || document;

    const zeigen = (text, warn) => {
      ergebnis.textContent = text;
      ergebnis.hidden = !text;
      ergebnis.classList.toggle('nb-tf__ergebnis--warn', !!warn);
    };

    const auswerten = (m, klicken) => {
      const soll = sollFuer(m, puq);
      if (!soll.length) { zeigen(box.dataset.tUnbekannt, true); return; }
      const satz = box.dataset.tPasst.replace('%MM', anzeigen(soll[0])).replace('%M', m.n);
      /* erste Empfehlung zuerst, dann die uebrigen passenden Groessen */
      let treffer = null;
      for (const s of soll) { treffer = werte.find((w) => gleich(zahl(w), s)); if (treffer) break; }
      if (!treffer) { zeigen(satz + ' ' + box.dataset.tFehlt, true); return; }
      if (klicken) {
        const knopf = Array.from(kauf.querySelectorAll('[data-nb-wert][data-nb-pos="' + pos + '"]'))
          .find((b) => b.getAttribute('data-nb-name') === treffer);
        if (knopf && !knopf.classList.contains('ist-aktiv')) knopf.click();
      }
      /* PUQ-Stempel fuer eine Marke, die PUQ nicht listet: von uns abgeleitet, dazusagen. */
      const hinweis = puq && m.qq === false && box.dataset.tAbgeleitet ? ' ' + box.dataset.tAbgeleitet : '';
      zeigen(satz + (klicken ? ' ' + box.dataset.tGewaehlt : '') + hinweis, false);
    };

    maschinen(box.dataset.quelle).then((daten) => {
      if (!daten.length) { box.hidden = true; return; }
      const index = daten.map((m) => ({ m, w: woerter(m.n) }));
      let aktiv = -1, treffer = [];
      const schliessen = () => { listeEl.hidden = true; eingabe.setAttribute('aria-expanded', 'false'); aktiv = -1; };
      const waehlen = (m) => {
        eingabe.value = m.n;
        schliessen();
        merken(m);
        auswerten(m, true);
      };
      const zeichnen = () => {
        listeEl.innerHTML = '';
        treffer.forEach((m, i) => {
          const li = document.createElement('li');
          li.setAttribute('role', 'option');
          li.id = listeEl.id + '-' + i;
          li.setAttribute('aria-selected', i === aktiv ? 'true' : 'false');
          li.textContent = m.n;
          /* pointerdown statt click: sonst schliesst blur die Liste vor dem Klick */
          li.addEventListener('pointerdown', (e) => { e.preventDefault(); waehlen(m); });
          listeEl.appendChild(li);
        });
        listeEl.hidden = !treffer.length;
        eingabe.setAttribute('aria-expanded', treffer.length ? 'true' : 'false');
        if (aktiv >= 0) eingabe.setAttribute('aria-activedescendant', listeEl.id + '-' + aktiv); else eingabe.removeAttribute('aria-activedescendant');
      };
      eingabe.addEventListener('input', () => {
        const q = woerter(eingabe.value);
        aktiv = -1;
        treffer = q.length ? index.map((x) => ({ m: x.m, p: punkte(q, x.w) })).filter((x) => x.p > 0)
          .sort((a, b) => b.p - a.p || a.m.n.localeCompare(b.m.n)).slice(0, 8).map((x) => x.m) : [];
        zeichnen();
        if (!q.length) zeigen('', false);
      });
      eingabe.addEventListener('keydown', (e) => {
        if (listeEl.hidden) return;
        if (e.key === 'ArrowDown') { aktiv = Math.min(aktiv + 1, treffer.length - 1); zeichnen(); e.preventDefault(); }
        else if (e.key === 'ArrowUp') { aktiv = Math.max(aktiv - 1, 0); zeichnen(); e.preventDefault(); }
        else if (e.key === 'Enter') { const m = treffer[aktiv >= 0 ? aktiv : 0]; if (m) { waehlen(m); e.preventDefault(); } }
        else if (e.key === 'Escape') { schliessen(); }
      });
      eingabe.addEventListener('blur', () => setTimeout(schliessen, 150));
      eingabe.addEventListener('focus', () => { if (treffer.length) zeichnen(); });
      const alt = gemerkt();
      if (alt && alt.n) {
        const frisch = daten.find((x) => x.h === alt.h) || alt;
        eingabe.value = frisch.n;
        /* Kam der Kunde mit ?variant= auf die Seite, bleibt seine Wahl. */
        auswerten(frisch, !new URLSearchParams(location.search).has('variant'));
      }
    });
  };

  /* ---------- Pruefung im Warenkorb ---------- */
  class NbTamperPruefung extends HTMLElement {
    connectedCallback() {
      let daten = [];
      try { daten = JSON.parse(this.querySelector('script').textContent || '[]'); } catch (e) { return; }
      const zubehoer = daten.filter((d) => d.pos > 0);
      if (!zubehoer.length) return;
      const imKorb = daten.filter((d) => liste(d.t).length || liste(d.s).length);
      let maschine = imKorb[0] || null;
      let sanft = false;
      if (!maschine) {
        const m = gemerkt();
        if (m) { maschine = { n: m.n, t: m.t, s: m.q }; sanft = true; }
      }
      if (!maschine) return;
      const hinweise = [];
      zubehoer.forEach((z) => {
        const soll = z.puq && liste(maschine.s).length ? liste(maschine.s) : liste(maschine.t);
        if (!soll.length) return;
        const ist = zahl(z.o[z.pos - 1]);
        /* nur plausible Siebtraeger-Durchmesser, 49 bis 61 mm */
        if (ist == null || ist < 49 || ist > 61 || soll.some((s) => gleich(s, ist))) return;
        /* gleiche uebrige Optionen (Farbe, Holz), nur die Groesse anders */
        const ziel = (z.vs || []).find((v) => v.a && gleich(zahl(v.o[z.pos - 1]), soll[0]) &&
          v.o.every((w, i) => i === z.pos - 1 || w === z.o[i]));
        const text = (sanft ? this.dataset.tSanft : this.dataset.tWarnung)
          .replace('%M', maschine.n).replace('%S', anzeigen(soll[0])).replace('%P', z.n).replace('%I', anzeigen(ist));
        hinweise.push({ z, ziel, text });
      });
      if (!hinweise.length) return;
      this.innerHTML = '';
      hinweise.forEach(({ z, ziel, text }) => {
        const box = document.createElement('div');
        box.className = 'nb-tw__box';
        box.setAttribute('role', 'status');
        const p = document.createElement('p');
        p.className = 'nb-tw__text';
        p.textContent = text;
        box.appendChild(p);
        if (ziel) {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'nb-tw__knopf';
          b.textContent = this.dataset.tTauschen;
          b.addEventListener('click', () => this.tauschen(z, ziel, b, p));
          box.appendChild(b);
        }
        this.appendChild(box);
      });
    }

    tauschen(z, ziel, knopf, p) {
      knopf.disabled = true;
      const json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      const wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(wurzel + 'cart/change.js', { method: 'POST', headers: json, body: JSON.stringify({ id: z.key, quantity: 0 }) })
        .then((r) => { if (!r.ok) throw new Error(r.status); return fetch(wurzel + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: ziel.id, quantity: z.q }] }) }); })
        .then((r) => {
          if (!r.ok) throw new Error(r.status);
          if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
          if (typeof nbWarenkorbAbgleichen === 'function') nbWarenkorbAbgleichen('nb-tamper');
          else location.reload();
        })
        .catch(() => { knopf.disabled = false; p.textContent = this.dataset.tFehler; });
    }
  }
  if (!customElements.get('nb-tamper-pruefung')) customElements.define('nb-tamper-pruefung', NbTamperPruefung);

  const start = () => document.querySelectorAll('[data-nb-tf]').forEach(finderStarten);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
